import { jsx as _jsx } from "react/jsx-runtime";
import OptionList from './OptionList';
import { getTranslation } from '../translations';
const EnvironmentSelector = ({ environments, loading, error, onSelect, }) => {
    const labels = getTranslation();
    return (_jsx(OptionList, { title: labels.selectEnvironment, loading: loading, error: error, options: environments.map((env) => ({
            id: env.name,
            label: env.name,
            detail: env.type,
            value: env.name,
        })), onSelect: onSelect }));
};
export default EnvironmentSelector;
